import React, { useState } from "react";
import AboutEditor from "./sections/AboutEditor";
import MethodologyEditor from "./sections/MethodologyEditor";
import DataTextEditor from "./sections/DataTextEditor";
import DataSourcesEditor from "./sections/DataSourcesEditor";
import DatasetUploadEditor from "./sections/DatasetUploadEditor";

const SECTIONS = [
    { id: "about", label: "О проекте" },
    { id: "methodology", label: "Методика" },
    { id: "data-text", label: "Данные — текст" },
    { id: "data-sources", label: "Данные — наборы" },
    { id: "dataset-upload", label: "Данные — каталог (xlsx)" },
];

const AdminDashboard = ({ onLogout }) => {
    const [section, setSection] = useState("about");

    return (
        <div className="admin-shell">
            <aside className="admin-sidebar">
                <div className="admin-sidebar-title">Геокарбон · Админка</div>
                <nav className="admin-sidebar-nav">
                    {SECTIONS.map((s) => (
                        <button
                            key={s.id}
                            className={`admin-sidebar-link ${
                                section === s.id ? "active" : ""
                            }`}
                            onClick={() => setSection(s.id)}
                        >
                            {s.label}
                        </button>
                    ))}
                </nav>
                <a
                    className="admin-sidebar-link admin-sidebar-view-site"
                    href="/"
                >
                    ← Открыть сайт
                </a>
                <button className="admin-sidebar-logout" onClick={onLogout}>
                    Выйти
                </button>
            </aside>

            <main className="admin-content">
                {section === "about" && <AboutEditor />}
                {section === "methodology" && <MethodologyEditor />}
                {section === "data-text" && <DataTextEditor />}
                {section === "data-sources" && <DataSourcesEditor />}
                {section === "dataset-upload" && <DatasetUploadEditor />}
            </main>
        </div>
    );
};

export default AdminDashboard;
